import CustomTable from "@/shared/components/common/table";
import CustomButton from "@/shared/components/kit/button";
import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
/**
 * ListCreditsStore
 *
 * نمایش لیست اعتبارات کاربر در فروشگاه.
 * این کامپوننت شامل:
 * - عنوان بخش
 * - دکمه افزودن اعتبار جدید
 * - جدول لیست اعتبارات
 * - نمایش حالت خالی در صورت عدم وجود داده
 *
 * کامپوننت به صورت واکنش‌گرا طراحی شده است:
 * - جهت‌دهی و چینش دکمه و عنوان در صفحه‌های کوچک به صورت ستونی
 * - جدول با overflow افقی برای موبایل
 * - دکمه در موبایل عرض 100% دارد
 *
 * @returns JSX.Element
 */

const ListCreditsStore = () => {
  const dataHeader = [
    { id: "rowId", title: "شناسه" },
    { id: "amount", title: "مبلغ اعتبار (ریال)" },
    { id: "type", title: "مدت باز پرداخت" },
    { id: "merchant_name", title: "پایان اعتبار" },
    { id: "ts", title: "عملیات" },
  ];

  const fakeData: any = [];
  return (
    <CardKit sx={{ bgcolor: "#2C2C2C"}}>
      <StackKit sx={{ width: "100%" }}>
        <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
          <TypoGraphyKit variant="body1">
            لیست اعتبارات کاربر در فروشگاه
          </TypoGraphyKit>
          <CustomButton>
            <TypoGraphyKit variant="body1">اعتبار جدید</TypoGraphyKit>
          </CustomButton>
        </StackKit>
        <CustomTable dataHeader={dataHeader} dataTbody={fakeData} />
        <StackKit sx={{width: "100%",bgcolor: "#323232",borderRadius: "8px",height: "50px",}} justifyContent={"center"} alignItems={"center"}>
          <TypoGraphyKit variant="body1">دیتایی وجود ندارد</TypoGraphyKit>
        </StackKit>
      </StackKit>
    </CardKit>
  );
};

export default ListCreditsStore;
